import React, { useState } from "react";
import "./home.scss";
import Navbar from "../../components/Landing_Navbar/Navbar";
import Home_Footer from "../../components/Footer_Home/Home_Footer";
import Tutorial from "../../components/Tutorial/Tutorial";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import serviceImg from "../../assets/display-image.png";
import login_Page from "../../assets/login_Page.png";
import ServicesPage from "../../components/Services/servicesPage";

export default function Home() {
  const navigate = useNavigate();
  const handleCrtClk = () => {
    navigate("/login");
  };

  return (
    <div className="home">
      {/* Navbar */}
      <Navbar />
      {/* Call-to-Action (CTA) Button */}
      <div className="lowerContainer">
        <section id="home">
          <div className="cta-banner">
            <button>✨ Keen and efficient in resolving your issues ✅</button>
          </div>

          <div className="hero">
            <h1>Streamline customer-queries and resolve issues with</h1>
            {/* Arwa's Code */}
            <motion.h2
              className="brand"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1.5, opacity: 1 }}
              transition={{ duration: 0.6, yoyo: Infinity, ease: "easeInOut" }}
            >
              <div className="logoContainer">
                <div className="upperText"> HelpNexis </div>
                <div className="lowerText"> Ticketing Solution</div>
              </div>
            </motion.h2>
            {/*Uptill here!*/}
            <p>
              HelpNexis is a powerful yet easy-to-use platform that connects
              customer queries with our skilled experts. It streamlines
              communication and issue tracking to quickly identify and resolve
              problems at their root. With HelpNexis, expect faster resolutions,
              improved satisfaction, and seamless support!
            </p>
            <button className="startBtn" onClick={handleCrtClk}>
              Click here to Begin !
            </button>
          </div>

          {/* Services popup should come AFTER the bold text */}
          <div className="services-popup">
            <div className="card-view">
              <img
                src={serviceImg}
                alt="Service Explanation"
                className="annotated-image"
              />
            </div>
          </div>

          {/*Komal's code*/}
          <div className="info-section">
            <div className="image-container">
              <img
                src={login_Page}
                alt="HelpNexis LoginPage"
                className="login-img"
              />
            </div>
            <div className="text-container">
              <h3>
                What’s{" "}
                <span className="highlight">
                  {" "}
                  <b>HelpNexis?</b>
                </span>{" "}
                A smart tool for managing customer doubts!
              </h3>
              <p>
                HelpNexis empowers customers to easily report issues, track
                progress, and stay updated on resolutions—all in one place.
              </p>
              <p className="bold-text">
                “Experience seamless communication and faster solutions with
                just a few clicks!”
              </p>
            </div>
          </div>
        </section>
        <section id="services">
          <ServicesPage />
        </section>
        <section id="tutorial">
          <Tutorial />
        </section>
      </div>
      {/* Footer */}
      <Home_Footer />
    </div>
  );
}
